
export default {
  methods: {
    calcAge(birth) {
      const date = new Date();
      let year = date.getFullYear();
      let month = (date.getMonth() + 1);
      let day = date.getDate();

      if (month < 10) month = '0' + month;
      if (day < 10) day = '0' + day;

      let monthDay = month.toString() + day.toString();

      birth = birth.replace('-', '').replace('-', '');

      let birthdayy = birth.substr(0, 4);
      let birthdaymd = birth.substr(4, 4);
      let age = Number(monthDay) < Number(birthdaymd) ? 
        Number(year) - Number(birthdayy) - 1 : Number(year) - Number(birthdayy);

      return age;
    },
    calcBMI(weight, height) {
      height = (height / 100)
      console.log('calcBMI', height)
      return Number(parseFloat(weight / (height * height)).toFixed(2))
    },
    shareKakao(shareObj) {
      // eslint-disable-next-line
      Kakao.Link.sendDefault({
        objectType: 'feed',
        content: {
          title: shareObj.title,
          imageUrl: '',
          description: shareObj.desc,
          link: {
            mobileWebUrl: shareObj.url,
          }
        }
      });
    },
  }
}
